module.exports = __webpack_public_path__ + "img/cola.4469724d.png";